import axios from '../../../axios';
import { VendorContactDTO } from '../types/VendorContactDTO';
import { VendorDocumentDTO } from '../types/VendorDocumentDTO';
import { VendorDTO } from '../types/VendorDTO';
import { VendorRequestDTO } from '../types/VendorRequestDTO';

const url = '/candidatesearch/api/vendors';
const urlContact = '/candidatesearch/api/vendor-contact';
const urlDocument = '/candidatesearch/api/vendor-documents';

export const createVendor = (vendor: VendorDTO) => axios.post(`${url}`, vendor);
export const getVendorsListNew = (request: VendorRequestDTO) => axios.post(`${url}/list`, request);
export const getVendorById = (id: string) => axios.get(`${url}/${id}`);
export const createVendorContact = (vendorContact: VendorContactDTO) =>
  axios.post(`${urlContact}/create`, vendorContact);
export const getVendorContactsListNew = (request: VendorRequestDTO) =>
  axios.post(`${urlContact}/list`, request);
export const getVendorContactByVendorId = (vendorId: string) =>
  axios.get(`${urlContact}/getall/vendor/${vendorId}`);
export const createVendorDocument = (vendorDocument: VendorDocumentDTO) =>
  axios.post(`${urlDocument}`, vendorDocument);
export const getVendorDocuments = (vendorId: string) =>
  axios.get(`${urlDocument}/vendor/${vendorId}`);
export const getVendorDocumentCategories = () => axios.get(`${urlDocument}/getallcategories`);
export const getVendorContactById = (id: string) => axios.get(`${urlContact}/${id}`);
export const updateVendorStatusById = (id: string, markStatus: boolean) =>
  axios.put(`${url}/update-status/${id}/${markStatus}`);
